























import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import CreateRole from './create-role.vue'
import EditRole from './edit-role.vue'
import myTable from '../../../components/table/my-table.vue'

class PageRoleRequest extends PageRequest{
    keyword:string='';
}

@Component({
    components:{CreateRole,EditRole}
})
export default class Roles extends AbpBase{
    editData:any = {}
    edit(c:any){
        this.modalTitle = '编辑'
        this.editData = Object.assign({},c)
        this.createModalShow=true;
    }
    modalTitle = '新增'
    pagerequest:PageRoleRequest=new PageRoleRequest();

    createModalShow:boolean=false;
    editModalShow:boolean=false;
    get list(){
        return this.$store.state.role.list;
    };
    get loading(){
        return this.$store.state.role.loading;
    }
    create(){
        this.modalTitle = '新增'
        this.createModalShow=true;
    }
    pageChange(page:number){
        this.$store.commit('role/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('role/setPageSize',pagesize);
        this.getpage();
    }
    async getpage(){

        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;

        await this.$store.dispatch({
            type:'role/getAll',
            data:this.pagerequest
        })
    }
    get pageSize(){
        return this.$store.state.role.pageSize;
    }
    get totalCount(){
        return this.$store.state.role.totalCount;
    }
    get currentPage(){
        return this.$store.state.role.currentPage;
    }

    columns=[{
        title:this.L('RoleName'),
        key:'name'
    },{
        title:this.L('DisplayName'),
        key:'displayName'
    },{
        title:this.L('Description'),
        key:'description'
    },{
        title:this.L('IsStatic'),
        render:(h:any,params:any)=>{
            return h('span',params.row.isStatic?this.L('Yes'):this.L('No'))
        }
    },{
        title:this.L('Actions'),
        key:'Actions',
        width:100,
        render:(h:any,params:any)=>{
            return h('div',[
                h('el-button',{
                    props:{
                        type:'text',
                        size:'small',
                    },
                    directives:[{
                        name:'allow'
                    }],
                    style:{
                        marginRight:'5px'
                    },
                    on:{
                        click:()=>{
                            this.$store.commit('material/edit',params.row);
                            this.edit(params.row);
                        }
                    }
                },this.L('Edit')),
                h('el-button',{
                    props:{
                        type:'error',
                        size:'small'
                    },
                    directives:[{
                        name:'allow'
                    }],
                    on:{
                        click:async ()=>{
                            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示',{
                                confirmButtonText:this.L('Yes'),
                                cancelButtonText:this.L('No')})
                                .then(async () => {
                                    await this.$store.dispatch({
                                        type:'role/delete',
                                        data:params.row
                                    })
                                    await this.getpage();
                                })
                                .catch(() => {

                                });
                        }
                    }
                },this.L('Delete'))
            ])
        }
    }]
    async created(){
        this.getpage();
        await this.$store.dispatch({
            type:'role/getAllPermissions'
        })
    }
}
